import { ADModalBody, AdvancedDragModal } from "src/componentsUtils/AdvancedDragModal";
import { GlassBox, GlassFoldUdBox } from "src/propertyInfoTemplates/PropertyComponents";
import { GlassButton, GlassButtonRow } from "./GlassButtons";
import { closeWindow, ManagedWindow } from "src/WindowManager/WindowState";
import { useRef, useState } from "react";
import { message } from "./Message";
import { DC } from "src/dataCollector/DataCollector";
import { useWindowContext } from "src/WindowManager/useWindowContext";
import { GlassInfo } from "./MitGlassComponents";

export function GraphQLDemo({ window }: { window: ManagedWindow }) {
   const [responseData, setResponseData] = useState<string | null>(null);
   const inputRef = useRef<HTMLTextAreaElement>(null);
   const { dispatch: windowDispatch } = useWindowContext();

   function handleFetch() {
      let query = inputRef.current?.value || "";
      message.progress("Fetching data from GraphQL...");
      DC.DF_GQL.query(query).then((data) => {
         setResponseData(JSON.stringify(data, null, 2));
         message.info("Data fetched successfully.");
      }).catch((err) => {
         message.error("Error fetching data: " + err.message);
      }).finally(() => {
         message.progress();
      });
   }

   return (
      <AdvancedDragModal
         window={window}
         PosDefault={{ width: "700px", height: "500px" }}
         title={"GraphQL Demo"}
         onClose={() => windowDispatch(closeWindow(window.id))}
      >
         <ADModalBody>
            <GlassInfo>
               <p>This is a demo of how to use the GraphQL data fetcher.</p>
               <p>Get schema to use in bruno etc... <a
                  href={DC.DF_GQL.getSchemaURL()}
               >Schema</a></p>
            </GlassInfo>
            <GlassBox title={"Query"}>
               <textarea ref={inputRef} style={{ width: "100%", minHeight: "400px", fontFamily: "consolas" }} defaultValue={defaultExample}></textarea>
            </GlassBox>
            <GlassButtonRow><GlassButton onClick={handleFetch}>Fetch</GlassButton></GlassButtonRow>
            <GlassFoldUdBox title={"Response"} foldetUd={true}>
               <textarea style={{ width: "100%", minHeight: "400px", fontFamily: "consolas" }} value={responseData || ""} readOnly></textarea>
            </GlassFoldUdBox>
         </ADModalBody>
      </AdvancedDragModal>
   )
}

const defaultExample = `
   query {
   MAT_SamletFastEjendom(
      virkningstid: "2024-11-12T13:31:33z" 
      registreringstid: "2024-11-12T13:31:33z" 
      where: { BFEnummer: { in: [100027966, 2120920] } }
   ) {
      nodes {
         BFEnummer
         status

         jordstykkeSamlesISamletFastEjendom {
         nodes {
            status
            matrikelnummer
            jordstykkeLiggerIEjerlav {
               ejerlavskode
               ejerlavsnavn
            }
         }
         }
      }
   }
   }
`